import React from "react";
import styled from "styled-components";
import { CheckIcon } from "@origin-digital/icon";
import { Text, Colors } from "@origin-digital/style-guide";
import { Box } from "@origin-digital/layout";
var StyledCheckIcon = styled(CheckIcon).withConfig({
  displayName: "TickList__StyledCheckIcon",
  componentId: "sc-1pz5yio-0"
})(["margin-top:3px;"]);
export var ListItem = function ListItem(_ref) {
  var text = _ref.text;
  return text ? React.createElement(Box, {
    display: "flex",
    direction: "row",
    marginTop: 1
  }, React.createElement(StyledCheckIcon, {
    color: "lightGreen"
  }), React.createElement(Box, {
    marginTop: 1,
    marginLeft: 2
  }, React.createElement(Text, {
    size: "sm"
  }, text))) : null;
};
var StyledText = styled(Text).withConfig({
  displayName: "TickList__StyledText",
  componentId: "sc-1pz5yio-1"
})(["a{color:", ";&:hover{text-decoration:none;color:", ";}}"], Colors.RED, Colors.RED);
export var TickList = function TickList(_ref2) {
  var _ref2$content = _ref2.content,
      item1 = _ref2$content.item1,
      item2 = _ref2$content.item2,
      item3 = _ref2$content.item3,
      subHeading = _ref2$content.subHeading,
      subHeadingWeight = _ref2$content.subHeadingWeight;
  var hasListItems = item1 || item2 || item3;
  return React.createElement(Box, {
    flex: "grow",
    marginTop: 4
  }, subHeading && React.createElement(StyledText, {
    size: "sm",
    fontWeight: subHeadingWeight
  }, React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: subHeading
    }
  })), hasListItems && React.createElement(Box, {
    marginBottom: 3
  }, React.createElement(ListItem, {
    text: item1
  }), React.createElement(ListItem, {
    text: item2
  }), React.createElement(ListItem, {
    text: item3
  })));
};